/** Append/channel stems follow edge stroke so factory edit wires stay visible on the canvas. */
export const CANVAS_CONNECTOR_COLOR = "var(--xy-edge-stroke, var(--sp-handle-border, #C9D5E1))";

/** Default edge stroke stored on persisted React Flow edges from older builds. */
export const CANVAS_EDGE_STORED_STROKE = "#C9D5E1";
